/* SOVA — minimal, kein Framework. Alles progressiv: ohne JS bleibt die Seite lesbar. */
(function () {
  "use strict";
  document.documentElement.classList.remove("no-js");
  var reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  /* ---------- Fade-in ---------- */
  function motion() {
    var els = document.querySelectorAll(".rise:not(.in)");
    if (reduce || !("IntersectionObserver" in window)) {
      els.forEach(function (e) { e.classList.add("in"); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        var d = parseInt(en.target.dataset.delay || 0, 10);
        setTimeout(function () { en.target.classList.add("in"); }, d);
        io.unobserve(en.target);
      });
    }, { rootMargin: "0px 0px -8% 0px", threshold: 0.06 });
    els.forEach(function (e) { io.observe(e); });
  }

  /* ---------- Akkordeon ---------- */
  function accordions(root) {
    (root || document).querySelectorAll("[data-acc]").forEach(function (acc) {
      if (acc.dataset.bound) return;
      acc.dataset.bound = "1";
      acc.querySelectorAll(".acc-q").forEach(function (q) {
        var item = q.closest(".acc-i");
        var panel = item.querySelector(".acc-a");
        var open = item.classList.contains("open");
        panel.style.height = open ? "auto" : "0px";
        q.setAttribute("aria-expanded", open ? "true" : "false");
        q.addEventListener("click", function () {
          var isOpen = item.classList.contains("open");
          if (acc.dataset.acc === "single") {
            acc.querySelectorAll(".acc-i.open").forEach(function (o) {
              if (o === item) return;
              o.classList.remove("open");
              o.querySelector(".acc-a").style.height = "0px";
              o.querySelector(".acc-q").setAttribute("aria-expanded", "false");
            });
          }
          if (isOpen) {
            panel.style.height = panel.scrollHeight + "px";
            requestAnimationFrame(function () { panel.style.height = "0px"; });
            item.classList.remove("open");
            q.setAttribute("aria-expanded", "false");
          } else {
            item.classList.add("open");
            q.setAttribute("aria-expanded", "true");
            panel.style.height = panel.scrollHeight + "px";
            panel.addEventListener("transitionend", function te(e) {
              if (e.propertyName !== "height") return;
              if (item.classList.contains("open")) panel.style.height = "auto";
              panel.removeEventListener("transitionend", te);
            });
          }
        });
      });
    });
  }

  /* ---------- Galerie ---------- */
  function galleries() {
    document.querySelectorAll("[data-gal]").forEach(function (gal) {
      if (gal.dataset.bound) return;
      gal.dataset.bound = "1";
      var slides = [].slice.call(gal.querySelectorAll(".gal-slide"));
      var thumbs = [].slice.call(gal.querySelectorAll(".gal-th"));
      var dots = [].slice.call(gal.querySelectorAll(".gal-dot"));
      if (slides.length < 2) return;
      /* Startbild kommt aus dem Markup: Bei ?variant=... ist das die gewaehlte Farbe. */
      var start = parseInt(gal.dataset.start || "0", 10);
      if (!(start >= 0 && start < slides.length)) start = 0;
      var i = start;

      function go(n) {
        i = (n + slides.length) % slides.length;
        slides.forEach(function (s, k) {
          s.classList.toggle("on", k === i);
          var v = s.querySelector("video");
          if (v) { if (k === i) { var p = v.play(); if (p && p.catch) p.catch(function(){}); } else { v.pause(); } }
        });
        thumbs.forEach(function (t, k) {
          t.classList.toggle("on", k === i);
          t.setAttribute("aria-selected", k === i ? "true" : "false");
        });
        dots.forEach(function (d, k) { d.classList.toggle("on", k === i); });
      }
      thumbs.forEach(function (t, k) { t.addEventListener("click", function () { go(k); }); });
      dots.forEach(function (d, k) { d.addEventListener("click", function () { go(k); }); });

      /* Swipe */
      var x0 = null, y0 = null;
      var main = gal.querySelector(".gal-main");
      main.addEventListener("touchstart", function (e) {
        x0 = e.touches[0].clientX; y0 = e.touches[0].clientY;
      }, { passive: true });
      main.addEventListener("touchend", function (e) {
        if (x0 === null) return;
        var dx = e.changedTouches[0].clientX - x0;
        var dy = e.changedTouches[0].clientY - y0;
        if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy)) go(i + (dx < 0 ? 1 : -1));
        x0 = null; y0 = null;
      }, { passive: true });

      gal.addEventListener("keydown", function (e) {
        if (e.key === "ArrowRight") go(i + 1);
        if (e.key === "ArrowLeft") go(i - 1);
      });
      go(start);
      gal.goTo = go;
    });
  }

  /* ---------- Menge ---------- */
  function qty() {
    document.querySelectorAll("[data-qty]").forEach(function (w) {
      if (w.dataset.bound) return;
      w.dataset.bound = "1";
      var inp = w.querySelector("input");
      w.querySelectorAll("button").forEach(function (b) {
        b.addEventListener("click", function () {
          var v = parseInt(inp.value, 10) || 1;
          v += (b.dataset.step === "up" ? 1 : -1);
          inp.value = Math.max(1, Math.min(99, v));
          inp.dispatchEvent(new Event("change", { bubbles: true }));
        });
      });
    });
  }

  /* ---------- Varianten + Sticky ---------- */
  function product() {
    var form = document.querySelector("[data-pform]");
    if (!form) return;
    var dataEl = document.getElementById("pdp-variants");
    if (!dataEl) return;
    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }

    // Preise kommen fertig formatiert aus Liquid (price_fmt). Falls ein aelteres
    // Template das Feld nicht liefert, greift der Fallback-Formatter darunter.
    var money = form.dataset.moneyFormat || "{{amount}}";
    function grp(s, sep) { return s.replace(/\B(?=(\d{3})+(?!\d))/g, sep); }
    function fmtCents(cents) {
      return money.replace(/\{\{\s*(\w+)\s*\}\}/g, function (_, t) {
        var d = t.indexOf("no_decimals") > -1 ? 0 : 2, ts = ",", ds = ".";
        if (t.indexOf("comma_separator") > -1) { ts = "."; ds = ","; }
        else if (t.indexOf("apostrophe_separator") > -1) { ts = "'"; ds = "."; }
        else if (t.indexOf("space_separator") > -1) { ts = "\u202f"; ds = t.indexOf("period_and") > -1 ? "." : ","; }
        var pr = ((cents || 0) / 100).toFixed(d).split(".");
        return grp(pr[0], ts) + (d ? ds + pr[1] : "");
      });
    }
    function fmt(v) { return (v && v.price_fmt) || fmtCents(v && v.price); }

    var selected = {};
    form.querySelectorAll("[data-opt]").forEach(function (btn) {
      var idx = btn.dataset.optIdx;
      if (btn.classList.contains("on")) selected[idx] = btn.dataset.optValue;
    });

    function findVariant() {
      return variants.filter(function (v) {
        return Object.keys(selected).every(function (k) {
          return String(v.options[k]) === String(selected[k]);
        });
      })[0];
    }

    function availableFor(idx, value) {
      var probe = {};
      Object.keys(selected).forEach(function (k) { if (k !== idx) probe[k] = selected[k]; });
      probe[idx] = value;
      return variants.some(function (v) {
        return Object.keys(probe).every(function (k) { return String(v.options[k]) === String(probe[k]); }) && v.available;
      });
    }

    var idInput = form.querySelector('[name="id"]');
    var priceEl = document.querySelector("[data-price]");
    var wasEl = document.querySelector("[data-price-was]");
    var unitEl = document.querySelector("[data-unit]");
    var addBtn = form.querySelector("[data-add]");
    var addLabel = addBtn ? addBtn.querySelector("span") : null;
    var stickP = document.querySelector("[data-stick-price]");

    function render() {
      var v = findVariant();
      form.querySelectorAll("[data-opt]").forEach(function (btn) {
        var on = String(selected[btn.dataset.optIdx]) === String(btn.dataset.optValue);
        btn.classList.toggle("on", on);
        btn.setAttribute("aria-pressed", on ? "true" : "false");
        btn.classList.toggle("out", !availableFor(btn.dataset.optIdx, btn.dataset.optValue));
      });
      form.querySelectorAll("[data-opt-current]").forEach(function (el) {
        el.textContent = selected[el.dataset.optCurrent] || "";
      });
      if (!v) return;
      if (idInput) idInput.value = v.id;
      if (priceEl) priceEl.textContent = fmt(v);
      if (stickP) stickP.textContent = fmt(v);
      if (wasEl) {
        if (v.compare_at_price && v.compare_at_price > v.price) {
          wasEl.textContent = v.compare_fmt || fmtCents(v.compare_at_price); wasEl.hidden = false;
        } else { wasEl.hidden = true; }
      }
      if (unitEl) unitEl.textContent = v.unit || "";
      if (addBtn) {
        addBtn.disabled = !v.available;
        addBtn.classList.toggle("is-disabled", !v.available);
        if (addLabel) addLabel.textContent = v.available
          ? (addBtn.dataset.labelAdd || "In den Warenkorb")
          : (addBtn.dataset.labelSold || "Ausverkauft");
      }
      if (v.image_index != null) {
        var gal = document.querySelector("[data-gal]");
        if (gal && gal.goTo) gal.goTo(v.image_index);
      }
      if (history.replaceState) {
        var u = new URL(window.location.href);
        u.searchParams.set("variant", v.id);
        history.replaceState({}, "", u.toString());
      }
    }

    form.querySelectorAll("[data-opt]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        if (btn.classList.contains("out")) return;
        selected[btn.dataset.optIdx] = btn.dataset.optValue;
        render();
      });
    });
    render();

    /* Sticky bar */
    var stick = document.querySelector("[data-stick]");
    var anchor = document.querySelector("[data-stick-anchor]");
    if (stick && anchor && "IntersectionObserver" in window) {
      new IntersectionObserver(function (en) {
        stick.classList.toggle("on", !en[0].isIntersecting && en[0].boundingClientRect.top < 0);
      }, { threshold: 0 }).observe(anchor);
      var jump = stick.querySelector("[data-stick-add]");
      if (jump) jump.addEventListener("click", function (e) {
        e.preventDefault();
        if (addBtn && !addBtn.disabled) { addBtn.click(); }
      });
    }
  }

  /* ---------- Drawer ---------- */
  function drawer() {
    var d = document.querySelector("[data-drawer]");
    if (!d) return;
    var open = document.querySelector("[data-drawer-open]");
    var close = document.querySelector("[data-drawer-close]");
    function set(on) {
      d.classList.toggle("open", on);
      d.setAttribute("aria-hidden", on ? "false" : "true");
      document.body.style.overflow = on ? "hidden" : "";
      if (on) { var f = d.querySelector("a,button"); if (f) f.focus(); }
      else if (open) open.focus();
    }
    if (open) open.addEventListener("click", function () { set(true); });
    if (close) close.addEventListener("click", function () { set(false); });
    d.querySelectorAll("a").forEach(function (a) { a.addEventListener("click", function () { set(false); }); });
    document.addEventListener("keydown", function (e) { if (e.key === "Escape") set(false); });
  }

  function init() {
    motion(); accordions(); galleries(); qty(); product(); drawer();
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
  else init();

  document.addEventListener("shopify:section:load", init);
})();
